export default {
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
};
